const API = process.env.API

export default {
  APLICACAO_GID: '77012f08-6c99-4b51-83bf-2cd070ab43f0',
  LOGIN: process.env.API + '/token',
  VERSAO: API + '/publico/versao',
  LOGO_EMPRESA: API + '/publico/logo',

  // ORGAO
  ORGAO: API + '/orgao',
  BUSCAR_LISTA_DE_ORGAOS: API + '/orgao/buscarListaOrgaos',

  // ASSUNTO
  ASSUNTO: API + '/assuntos',
  ASSUNTO_ROTEIRO: API + '/assuntos/descricao/roteiro',
  ASSUNTO_RELATORIO: API + '/assuntos/relatorio',

  // SITUACAO
  SITUACAO: API + '/situacoes',
  SITUACAO_MOVIMENTADO: API + '/situacoes/buscarSituacaoMovimentado',
  SITUACAO_CANCELADO: API + '/situacoes/buscarSituacaoCancelado',
  SITUACAO_ARQUIVADO: API + '/situacoes/buscarSituacaoArquivado',
  SITUACAO_ALTERAR: API + '/situacoes/buscarSituacaoAoAlterarSituacao',
  SITUACAO_ENCERRADO: API + '/situacoes/buscarSituacaoEncerrado',

  // SUB ASSUNTO
  SUB_ASSUNTO_COD_ASSUNTO: API + '/subassuntos/assunto',
  SUB_ASSUNTO: API + '/subassuntos',
  SUB_ASSUNTO_ROTEIRO: API + '/subassuntos/descricao/roteiro',

  DOCUMENTO: API + '/documentos',

  DOCUMENTACAO_NECESSARIA: API + '/documentacaoNecessarias',
  DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_SUB_ASSUNTO: API + '/documentacaoNecessarias/buscarPorTipoProcessoESubAssunto',
  DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_ASSUNTO_SUBASSUNTO: API + '/documentacaoNecessarias/buscarPorTipoProcessoEAssuntoSubAssunto',
  DOCUMENTACAO_NECESSARIA_TIPO_PROCESSO_E_ASSUNTO_SUBASSUNTO_ATIVOS: API + '/documentacaoNecessarias/buscarPorTipoProcessoEAssuntoSubAssuntoAtivos',

  TIPO_DE_PROCESSO: API + '/tiposDeProcessos',
  TIPO_DE_PROCESSO_ESPECIFICACAO: API + '/tiposDeProcessos/especificacao',
  TIPO_DE_PROCESSO_DESCRICAO: API + '/tiposDeProcessos/descricao',
  TIPO_DE_PROCESSO_ROTEIRO: API + '/tiposDeProcessos/descricao/roteiro',

  // UNIDADE
  UNIDADE: API + '/unidades',
  BUSCAR_UNIDADE_ORGAO: API + '/unidades/orgao',
  BUSCAR_UNIDADE_PELO_ORGAO: API + '/unidades/buscarUnidadePeloOrgao',

  // LOCALIZACAO
  LOCALIZACAO: API + '/localizacoes',
  LOCALIZACAO_PAI_VALIDO: API + '/localizacoes/procurarPaiValido',

  // SETOR
  SETOR: API + '/setores',
  SETOR_UNIDADE: API + '/setores/unidade',
  SETOR_ATIVO_UNIDADE: API + '/setores/buscarSetorAtivoPorUnidade',
  SETOR_COD_USUARIO: API + '/setores/buscarPorCodUsuario',

  //
  RESPONSAVEL_SETOR: API + '/responsavelSetor',
  RESPONSAVEL_SETOR_USUARIO: API + '/responsavelSetor/buscarPorUsuario',
  RESPONSAVEL_SETOR_USUARIO_SETOR_UNIDADE_ORGAO: API + '/responsavelSetor/buscarPorUsuarioSetorUnidadeOrgao',

  // JUSTIFICATIVA
  JUSTIFICATIVA: API + '/justificativas',
  JUSTIFICATIVA_SUBASSUNTO: API + '/justificativas/subassunto',

  // FORMA DE SOLICITAÇÃO
  FORMA_SOLICITACAO: API + '/formasSolicitacao',

  // REQUERENTE
  REQUERENTE: API + '/requerente',
  RELATORIO_REQUERENTE: API + '/requerente/relRequerente',
  BUSCAR_REQUERENTE_PELO_DOCUMENTO: API + '/requerente/documento',

  // CADASTRO DE PESSOAS
  NACIONALIDADE: API + '/nacionalidadeProtocolo',
  CIDADE: API + '/cidadeProtocolo',
  BAIRRO: API + '/bairroProtocolo',
  LOGRADOURO: API + '/logradouroProtocolo',
  BUSCAR_LISTA_UF: API + '/ufProtocolo/listar',
  BUSCAR_UF_PELA_SIGLA: API + '/buscarPelaSigla',
  PESSOA_FISICA: API + '/pessoaFisicaProtocolo',
  BUSCAR_PESSOA_FISICA_PELO_CPF: API + '/pessoaFisicaProtocolo/cpf',
  BUSCAR_PESSOA_FISICA_PELO_NOME: API + '/pessoaFisicaProtocolo/nome',
  PESSOA_JURIDICA: API + '/pessoaJuridicaProtocolo',
  BUSCAR_PESSOA_JURIDICA_PELA_RAZAO_SOCIAL: API + '/pessoaJuridicaProtocolo/desRazaoSocial',
  BUSCAR_PESSOA_JURIDICA_PELO_CNPJ: API + '/pessoaJuridicaProtocolo/cnpj',
  BUSCAR_LOCALIZACAO_PELO_CEP: API + '/localizacaoProtocolo/cep',
  BUSCAR_TODAS_LOCALIZACOES_PELO_CEP: API + '/localizacaoProtocolo/todos/cep',
  BUSCAR_TODAS_LOCALIZACOES_PELO_LOGRADOURO: API + '/localizacaoProtocolo/todos/logradouro',
  BUSCAR_ENDERECOS_PESSOA: API + '/buscarEnderecos',

  // ROTEIRO
  ROTEIRO: API + '/roteiro',
  ROTEIRO_BUSCAR_PARA_EDITAR: API + '/roteiro/buscarParaEditar',
  ROTEIRO_ASSUNTO: API + '/roteiro/buscarRoteiroPorAssunto',
  ROTEIRO_ASSUNTO_USUARIO: API + '/roteiro/buscarRoteiroPorAssuntoUsuario',
  ROTEIRO_SEQUENCIA: API + '/roteiro/listarSequenciaRoteiro',
  ROTEIRO_CODIGO: API + '/roteiro/codigosRoteiro',
  ROTEIRO_EXCLUIR_INTEIRO: API + '/roteiro/excluirRoteiroInteiro',

  // ABERTURA DE PROCESSO
  ABERTURA_PROCESSO: API + '/aberturaProcesso',
  ABERTURA_PROCESSO_BUSCAR_QUANTIDADE: API + '/aberturaProcesso/buscarQuantidade',
  ABERTURA_PROCESSO_BUSCAR_QUANTIDADE_PERMISSAO: API + '/aberturaProcesso/buscarQuantidadePermissao',
  ABERTURA_PROCESSO_BUSCAR_TODOS_PAGINADO: API + '/aberturaProcesso/buscarTodosPaginado',
  ABERTURA_PROCESSO_NUM_PROTOCOLO: API + '/aberturaProcesso/buscarPeloNumProtocolo',
  ABERTURA_PROCESSO_NUM_PROCESSO_ANO_PROCESSO: API + '/aberturaProcesso/buscarPeloNumProcessoAnoProcesso',
  ABERTURA_PROCESSO_PARA_REMESSA_PROCESSO: API + '/aberturaProcesso/buscarParaRemessaProcesso',
  ABERTURA_PROCESSO_PARA_JUNCAO_PROCESSO: API + '/aberturaProcesso/buscarParaJuncaoProcesso',
  ABERTURA_PROCESSO_DADOS_IMOVEL: API + '/aberturaProcesso/buscarDadosImovel',

  // MOVIMENTACAO DE PROCESSO
  MOVIMENTACAO_PROCESSO: API + '/movimentacaoProcesso',
  BUSCAR_MOVIMENTACAO_A_CONFIRMAR: API + '/movimentacaoProcesso/buscarMovimentacaoAConfirmar',
  BUSCAR_MOVIMENTACAO_NUM_SEQUENCIA: API + '/movimentacaoProcesso/buscarMovimentacaoPeloNumSequencia',
  BUSCAR_MOVIMENTACAO_DO_PROCESSO: API + '/movimentacaoProcesso/buscarMovimentacaoDoProcesso',
  MOVIMENTACAO_PROCESSO_ENVIAR_EMAIL: API + '/movimentacaoProcesso/enviarEmail',
  MOVIMENTACAO_SALVAR_ANEXO: API + '/movimentacaoProcesso/salvarAnexo',
  MOVIMENTACAO_BUSCAR_ARQUIVO: API + '/movimentacaoProcesso/buscarArquivo',

  // TIPO DE LOCALIZAÇÃO
  TIPO_LOCALIZACAO: API + '/tiposDeLocalizacao',

  // MOVIMENTACAO DA SITUAÇÃO DO PROCESSO
  MOVIMENTACAO_SITUACAO_PROCESSO: API + '/movimentacaoSituacaoProcesso',
  BUSCAR_MOVIMENTACAO: API + '/movimentacaoSituacaoProcesso/buscarMovimentacaoProcesso',

  // DOCUMENTO ANEXO PROCESSO
  DOCUMENTO_ANEXO_PROCESSO: API + '/documentoAnexoProcesso',
  BUSCAR_DOCUMENTO_ANEXO_PROCESSO_PELO_COD_PROCESSO: API + '/documentoAnexoProcesso/codProcesso',
  RELATORIO_DOCUMENTO_ANEXO_PROCESSO: API + '/documentoAnexoProcesso/relDocumentoAnexoProcesso',
  DOCUMENTO_ANEXO_PROCESSO_DOWNLOAD_ARQUIVO: API + '/documentoAnexoProcesso/downloadArquivo',
  DOCUMENTO_ANEXO_PROCESSO_DOWNLOAD_ARQUIVOS: API + '/publico/download/arquivo',
  DOCUMENTO_ANEXO_PROCESSO_ENVIAR_EMAIL_ARQUIVO_EXTERNO: API + '/documentoAnexoProcesso/enviarEmailArquivoExterno',

  // TIPO DE LOCALIZAÇÃO
  // TIPO_LOCALIZACAO: API + '/tiposDeLocalizacao',

  // SOLICITACAO DE ABERTURA
  PROTOCOLO_SOLICITACAO: API + '/protocoloSolicitacao',
  PROTOCOLO_SOLICITACAO_BUSCAR_PELO_COD_SOLICITACAO: API + '/protocoloSolicitacao/buscarPeloCodSolicitacao',
  PROTOCOLO_SOLICITACAO_MOVIMENTACAO: API + '/protocoloSolicitacaoMovimentacao',
  PROTOCOLO_SOLICITACAO_MOVIMENTACAO_NUMSOLICITACAO: API + '/protocoloSolicitacaoMovimentacao/buscarPeloNumSolicitacao',
  PROTOCOLO_SOLICITACAO_MOVIMENTACAO_DOCUMENTOS: API + '/protocoloSolicitacaoMovimentacao/buscarSolicitacaoDocumento',
  PROTOCOLO_SOLICITACAO_MOVIMENTACAO_DOWNLOAD_ARQUIVO: API + '/protocoloSolicitacaoMovimentacao/downloadArquivo',
  BUSCAR_PROTOCOLO_SOLICITACAO_DOCUMENTO: API + '/protocoloSolicitacaoDocumento',
  BUSCAR_PROTOCOLO_SOLICITACAO_MOVIMENTACAO_PELO_COD_SOLICITACAO: API + '/protocoloSolicitacaoMovimentacao/buscarPeloCodSolicitacao',

  // REMESSA DE PROCESSO
  REMESSA_PROCESSO: API + '/remessaProcesso',
  BUSCAR_REMESSA_PROCESSO_A_CONFIRMAR: API + '/remessaProcesso/buscarRemessaProcessoAConfirmar',
  REMESSA_PROCESSO_NUM_REMESSA_ANO_REMESSA: API + '/remessaProcesso/buscarPeloNumRemessaAnoRemessa',
  BUSCAR_REMESSA_PROCESSO_PELA_MOVIMENTACAO: API + '/remessaProcesso/buscarRemessaPelaMovimentacao',

  // PENDENCIA DE PROCESSO
  PENDENCIA_PROCESSO: API + '/pendenciaProcesso',
  PENDENCIA_PROCESSO_PROCESSO: API + '/pendenciaProcesso/buscarPorProcesso',

  // PARAMETROS DO SISTEMA
  PARAMETROS_SISTEMA: API + '/parametrosSistema',
  PARAMETROS_SISTEMA_ENVIAR_EMAIL: API + '/parametrosSistema/enviarEmail',

  // OBSERVACAO GERAL PROCESSO
  OBSERVACAO_GERAL_PROCESSO: API + '/observacaoGeralProcesso',
  OBSERVACAO_GERAL_PROCESSO_LISTA: API + '/observacaoGeralProcesso/buscarLista',

  // JUNÇÃO DE PROCESSOS
  JUNCAO_DE_PROCESSOS: API + '/juncaoProcesso',
  JUNCAO_DE_PROCESSOS_BUSCAR_NOVO: API + '/juncaoProcesso/buscarPaginaNovo',
  JUNCAO_DE_PROCESSOS_VISUALIZAR: API + '/juncaoProcesso/listarVisualizar',
  JUNCAO_DE_PROCESSOS_EDITAR: API + '/juncaoProcesso/criarListaDeNumProcessoParaEditar',
  JUNCAO_DE_PROCESSOS_BUSCAR_JUNCOES: API + '/juncaoProcesso/buscarJuncoes',
  JUNCAO_DE_PROCESSOS_PELA_MOVIMENTACAO: API + '/juncaoProcesso/buscarJuncaoPelaMovimentacao',
  JUNCAO_DE_PROCESSOS_BUSCAR_COD_PROCESSO_IND_SITUACAO: API + '/juncaoProcesso/buscarJuncaoPorProcessoSituacao',
  PAGINAR_MOVIMENTACAO_PELO_COD_PROCESSO: API + '/movimentacaoProcesso/paginarMovimentacaoPeloCodProcesso',
  BUSCAR_ABERTURA_PROCESSO_DOCUMENTO: API + '/aberturaProcessoDocumento',
  JUNCAO_DE_PROCESSOS_BUSCAR_JUNCOES_NUM_ANO: API + '/juncaoProcesso/buscarJuncaoPeloNumEAno',
  JUNCAO_DE_PROCESSOS_ATUALIZAR_SITUACAO: API + '/juncaoProcesso/atualizarSituacao',
  JUNCAO_DE_PROCESSOS_EXCLUIR: API + '/juncaoProcesso/excluirJuncaoInteira',

  // RELATÓRIO MOVIMENTAÇÃO DE PROCESSO
  RELATORIO_MOVIMENTACAO_PROCESSO: API + '/publico/ComprovanteMovimentacaoProcessoControlador/relatorioComprovanteMovimentacao',
  COMPROVANTE_MOVIMENTACAO_PROCESSO: API + '/publico/ComprovanteMovimentacaoProcessoControlador',
  RELATORIO_COMPROVANTE_ENCAMINHAMENTO: API + '/publico/ComprovanteEncaminhamentoProcessoControlador/relatorioComprovanteEncaminhamento',
  COMPROVANTE_ENCAMINHAMENTO: API + '/publico/ComprovanteEncaminhamentoProcessoControlador',

  // RELATÓRIO MOVIMENTAÇÃO DOS PROCESSOS
  RELATORIO_MOVIMENTACAO_PROCESSOS_GERAL: API + '/publico/RelatorioMovimentacaoProcessosControlador',
  RELACAO_RELATORIO_MOVIMENTACAO_PROCESSOS_GERAL: API + '/publico/RelatorioMovimentacaoProcessosControlador/relatorioMovimentacaoProcessos',

  // EMISSAO

  // ETIQUETA
  RELATORIO_EMISSAO_ETIQUETA: API + '/publico/relatorioEmissaoEtiquetaControlador',
  RELATORIO_EMISSAO_ETIQUETA_RELATORIO: API + '/publico/relatorioEmissaoEtiquetaControlador/relatorio',

  // RELATÓRIO NOTIFICAÇÃO DE COMPARECIMENTO
  NOTIFICACAO_SOLICITACAO_COMPARECIMENTO: API + '/publico/notificacaoSolicitacaoComparecimento',
  RELATORIO_NOTIFICACAO_SOLICITACAO_COMPARECIMENTO: API + '/publico/notificacaoSolicitacaoComparecimento/relatorioNotificacaoComparecimento',

  // RELATÓRIO NOTIFICAÇÃO COMUNICADO DE SITUAÇÃO DE PROCESSO
  NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO: API + '/publico/notificacaoComunicadoSituacaoProcesso',
  RELATORIO_NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO: API + '/publico/notificacaoComunicadoSituacaoProcesso/relatorioNotificacaoComunicadoSituacaoProcesso',

  // RELATÓRIO GERAL DE PROCESSOS
  RELATORIO_GERAL_PROCESSOS: API + '/publico/relatorioGeralProcessos',
  RELATORIO_RELATORIO_GERAL_PROCESSOS: API + '/publico/relatorioGeralProcessos/relatorio',

  // RELATÓRIO ROTEIROS DOS PROCESSOS
  RELATORIO_ROTEIROS_DOS_PROCESSOS: API + '/publico/relatorioRoteirosDosProcessos',
  RELATORIO_RELATORIO_ROTEIROS_DOS_PROCESSOS: API + '/publico/relatorioRoteirosDosProcessos/relatorio',

  // RELATÓRIO OBSERVAÇÕES POR SEQUÊNCIA
  RELATORIO_OBSERVACAO_SEQUENCIA: API + '/publico/RelatorioObservacaoSequencia',
  RELATORIO_RELATORIO_OBSERVACAO_SEQUENCIA: API + '/publico/RelatorioObservacaoSequencia/relatorio',

  // RELATÓRIO MAPA ESTATÍSTICO
  RELATORIO_MAPA_ESTATISTICO: API + '/publico/relatorioMapaEstatistico',
  RELATORIO_RELATORIO_MAPA_ESTATISTICO: API + '/publico/relatorioMapaEstatistico/relatorio',

  // RELATÓRIO PROCESSOS INCLUIDOS NA REMESSA
  RELATORIO_PROCESSOS_INCLUIDOS_REMESSA: API + '/publico/relatorioProcessosIncluidosRemessa',
  RELATORIO_RELATORIO_PROCESSOS_INCLUIDOS_REMESSA: API + '/publico/relatorioProcessosIncluidosRemessa/relatorio',

  // RELATÓRIO DE REMESSAS
  RELATORIO_REMESSAS_POR_PROCESSO: API + '/publico/relatorioRemessasPorProcesso',
  RELATORIO_RELATORIO_REMESSAS_POR_PROCESSO: API + '/publico/relatorioRemessasPorProcesso/relatorio',

  // RELATORIO CRYSTAL
  RELATORIO_CRYSTAL: API + '/relatorioLegado',

  // ACESSO MENU
  ACESSOS_MENU: API + '/usuario/acessos',

  // NOTIFICAÇÃO WEB
  NOTIFICACAO_SOLICITACAO: API + '/protocoloNotificacaoSolicitacao',
  BUSCAR_TODAS_NOTIFICACAO_SOLICITACAO: API + '/protocoloNotificacaoSolicitacao/buscarTodasNotificacoes',
  BUSCAR_NOTIFICACAO_SOLICITACAO_ATIVAS: API + '/protocoloNotificacaoSolicitacao/buscarNotificacoesAtivas',
  NOTIFICACAO_SOLICITACAO_USUARIO_MARCAR_COMO_LIDA: API + '/protocoloNotificacaoSolicitacaoUsuario/marcarNotificacaoComoLida',
  NOTIFICACAO_SOLICITACAO_USUARIO: API + '/protocoloNotificacaoSolicitacaoUsuario'
}
